module.exports = __webpack_public_path__ + "img/logo.25dff2f2.png";